import { useTheme } from '@mui/material/styles';
import { InstallationGuide } from 'modules/installation-guide';
import { Layout } from 'modules/minimal-ui-theme';

export const AppLandingPage = () => {
  const theme = useTheme();

  return (
    <Layout backgroundColor={theme.palette.background.default}>
      <InstallationGuide />
    </Layout>
  );
};
